(ns splash.ui.lender-portal.views.pages.search
  (:require
    ["react-router-dom" :refer [useHistory]]
    [reagent.core :as r]
    [splash.ui.lender-portal.common.formatters :as formatters]
    [splash.ui.lender-portal.common.util :as util]
    [splash.ui.lender-portal.components.layout :as layout]
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.search-box :refer [search-box]]
    [splash.ui.lender-portal.components.theme :refer [no-rows-search-illustration no-rows-found-illustration]]
    [splash.ui.lender-portal.state :as state]))

(def default-column-opts
  {:flex     1
   :sortable false})

(def columns
  (let [fields
        [{:field      "application-id"
          :headerName "Application ID"}
         {:field         "first-name"
          :headerName    "First Name"
          :cellClassName "dd-privacy-mask"}
         {:field         "last-name"
          :headerName    "Last Name"
          :cellClassName "dd-privacy-mask"}
         {:field         "success-status"
          :headerName    "Application Status"
          :cellClassName "dd-privacy-mask"}
         {:field         "final-loan-amount"
          :headerName    "Loan Amount"
          :cellClassName "dd-privacy-mask"
          :valueGetter   (fn [params]
                           (formatters/number->currency (.. params -value)))}
         {:field         "submitted-at"
          :headerName    "Submitted Date"
          :cellClassName "dd-privacy-mask"
          :valueFormatter (fn [params] (util/format-datetime-str (.. params -value)))}
         {:field         "closed-date"
          :headerName    "Closed Date"
          :cellClassName "dd-privacy-mask"
          :valueFormatter (fn [params] (util/format-datetime-str (.. params -value)))}]]
    (map #(merge default-column-opts %) fields)))

(defn initiate-search
  []
  (let [text   "Enter search criteria to begin"]
    [mui/stack {:display         "flex"
                :flex-direction  "column"
                :align-items     "center"
                :justify-content "center"
                :height          "100%"}
     [no-rows-search-illustration]
     [mui/typography {:sx {:mt          2
                           :color       "#444444"
                           :font-weight "600"}}
      text]]))

(defn no-results-search
  []
  (let [text         "No results found"]
    [mui/stack {:display               "flex"
                :flex-direction        "column"
                :align-items           "center"
                :justify-content       "center"
                :height                "100%"}
     [no-rows-found-illustration]
     [mui/typography {:sx {:mt          2
                           :color       "#444444"
                           :font-weight "600"}}
      text]]))

(defn loading-search
  []
  (let [text "Searching..."]
    [mui/stack {:display               "flex"
                :flex-direction        "column"
                :align-items           "center"
                :justify-content       "center"
                :height                "100%"}
     [mui/circular-progress]
     [mui/typography {:sx {:mt          2
                           :color       "#444444"
                           :font-weight "600"}}
      text]]))

(defn search-results
  []
  ;; using a make- function here to return a component instead of typical usage
  ;; trying to create the component first with a variant (e.g. [no-rows-overlay :initial])
  ;; throws reagent errors
  (r/with-let [state                   (state/use-state)
               loading                 (r/cursor state [:loading])
               search-results          (r/cursor state [:search-results])
               selected-application-id (r/cursor state [:selected-application-id])
               history                 (useHistory)]
    (cond
      (and (nil? @search-results)
        (false? @loading)) [initiate-search]
      (= [] @search-results) [no-results-search]
      (true? @loading) [loading-search]
      :else  [mui/data-grid {:columns              columns
                             :rows                 (or @search-results [])
                             :initialState         {:pagination {:paginationModel {:page     0
                                                                                   :pageSize 15}}}
                             :pageSizeOptions      [15 30 50 100]
                             :getRowId             #(aget % "application-id")
                             :onRowClick           (fn [params _ _]
                                                     (let [application-id (.-id params)]
                                                       (reset! selected-application-id application-id)
                                                       (.push history (str "/application/" application-id))))
                             ;; leaving this in here for now, but it doesn't seem to work anyway
                             ;; eventually we'll add it back so I don't think we need to figure out why
                             ;; instead, we added individual disabling of sorting to each field
                             :disableColumnSorting true
                             :disableColumnFilter  true
                             :sx                   {:padding "16px"}}])))

(defn view
  []
  [layout/default
   [layout/container
    [search-box]
    [search-results]]])
